module.exports = __webpack_public_path__ + "static/media/globe.68dabb9b.svg";